// src/services/api/tagging-rules.js
import api from './api-config';

export const taggingRulesApi = {
    // Get all tagging rules
    getRules: async () => {
        const response = await api.get('/tagging-rules');
        return response.data;
    },

    // Create a new tagging rule
    createRule: async (ruleData) => {
        const response = await api.post('/tagging-rules', ruleData);
        return response.data;
    },

    // Update an existing tagging rule
    updateRule: async (ruleId, ruleData) => {
        const response = await api.put(`/tagging-rules/${ruleId}`, ruleData);
        return response.data;
    },

    // Delete a tagging rule
    deleteRule: async (ruleId) => {
        const response = await api.delete(`/tagging-rules/${ruleId}`);
        return response.data;
    },

    // Toggle rule enabled/disabled status
    toggleRule: async (ruleId, enabled) => {
        const response = await api.patch(`/tagging-rules/${ruleId}/toggle`, { enabled });
        return response.data;
    },

    // Test a rule against existing transactions
    testRule: async (ruleData, limit = null) => {
        const params = limit ? { limit } : {};
        const response = await api.post('/tagging-rules/test', ruleData, {
            params
        });
        return response.data;
    },

    // Test an existing rule by ID
    testExistingRule: async (ruleId, limit = null) => {
        const params = limit ? { limit } : {};
        const response = await api.get(`/tagging-rules/${ruleId}/test`, {
            params
        });
        return response.data;
    },

    // Update rule priorities (for drag and drop reordering)
    updateRulePriorities: async (priorityUpdates) => {
        const response = await api.patch('/tagging-rules/priorities', { priorities: priorityUpdates });
        return response.data;
    },

    // Execute selected rules
    executeRules: async (ruleIds) => {
        const response = await api.post('/tagging-rules/execute', { ruleIds });
        return response.data;
    }
};

export default taggingRulesApi;